import { IEditorialFrameProps } from './editorialFrame.models';
import * as S from './editorialFrame.style';

export const EditorialFrame = ({ children, title, ...rest }: IEditorialFrameProps) => (
  <S.Article {...rest}>
    <S.Title>{title}</S.Title>
    {children}
  </S.Article>
);
